exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".v-container[data-v-271ce24c]{min-height:0}.flex .label[data-v-271ce24c]:after{content:\":\"}", "", {"version":3,"sources":["/Users/wvl/Workspaces/NowYu/nowyu-we/src/pages/Consent.vue"],"names":[],"mappings":"AACA,8BACE,YAAc,CACf,AACD,oCACE,WAAa,CACd","file":"Consent.vue","sourcesContent":["\n.v-container[data-v-271ce24c] {\n  min-height: 0;\n}\n.flex .label[data-v-271ce24c]:after {\n  content: \":\";\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-271ce24c","scoped":true,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Consent.vue
// module id = 375
// module chunks = 0